import styled from 'styled-components';

const MarkKeyword = styled.div`
	background: #fff2ac;
	display: initial;
`;

export default MarkKeyword;
